import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Guard GLOBAL de la rueda (C1 sexta tanda, 29-jul-2026): algunos navegadores
// cambian el valor de un input numérico ENFOCADO cuando la rueda pasa por encima
// (Firefox lo hace; Chromium lo hacía — MEDIDO en Chrome 150 que ya no, arnés
// tmp-arnes-rueda del 29-jul). La regla de index.css solo esconde las flechas —
// CSS no puede frenar el wheel en ningún navegador. Un −1 silencioso en
// "Efectivo contado" del cuadre de caja es un descuadre que alguien busca horas;
// este blur() elimina la CLASE entera del problema en cualquier navegador, a
// costo cero: el valor queda intacto y el scroll sigue normal (passive). Cubre
// los ~47 inputs type="number" de la app y cualquiera futuro.
document.addEventListener('wheel', (e) => {
  const el = document.activeElement;
  if (el instanceof HTMLInputElement && el.type === 'number' && e.target === el) el.blur();
}, { capture: true, passive: true });

// AG-3: portal público del cliente en /reservas/:tienda — página aparte, SIN el panel de Neto (ni
// login ni shell). Se detecta por la ruta ANTES de montar App, así el cliente (que no tiene usuario
// de Neto) nunca ve el panel. El resto de la app no cambia.
const portalMatch = window.location.pathname.match(/^\/reservas\/([^/]+)\/?$/);
const root = ReactDOM.createRoot(document.getElementById('root'));
if (portalMatch) {
  const PortalAgenda = React.lazy(() => import('./agenda/portal/PortalAgenda'));
  root.render(
    <React.StrictMode>
      <React.Suspense fallback={null}>
        <PortalAgenda tienda={decodeURIComponent(portalMatch[1])} />
      </React.Suspense>
    </React.StrictMode>
  );
} else {
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
